<template>
    <section class="projects" :class="$mq">
        <base-text type="h4" class="heading">{{ heading }}</base-text>
        <project
            v-for="(project, index) in projects"
            :key="index"
            :name="project.name"
            :developers="project.developers"
            :description="project.description"
            :video="project.video"
            :awards="project.award"
        />
    </section>
</template>

<script>
    import Project from './Project';

    export default {
        name: 'project-section',

        components: {
            Project,
        },

        props: {
            heading: {
                type: String,
                required: true,
            },

            projects: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    section.projects {
        margin-bottom: 50px;

        &:not(:first-of-type) {
            padding-top: 30px;
        }

        .heading {
            margin-bottom: 20px;
        }

        .project {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .project {
                margin-bottom: $standard-space-mobile;
            }
        }
    }
</style>
